import { render, staticRenderFns } from "./veJkyProjectEdit.vue?vue&type=template&id=4e0c1347&scoped=true"
import script from "./veJkyProjectEdit.vue?vue&type=script&lang=js"
export * from "./veJkyProjectEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0c1347",
  null
  
)

export default component.exports